import { themeAwardWidgetDecorator } from '../utils'
import { EngineeringAudit } from './EngineeringAudit'

export const EngineeringAuditWrapper = themeAwardWidgetDecorator(EngineeringAudit)
